export class CreateScheduleModel {
  doctorID: string;
  organizationID: string;
  name: string;
  TDOCID: string;
}
